import * as React from 'react';
import StartComponent from 'src/modules/commons/start/Start.component';

class CnmvAccreditationComponent extends React.Component {
  render() {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <h1 className="bold-title">
                Acreditación CNMV
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-12 col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Acreditación CNMV
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <p>
                <strong>
                  The Crowd Angel tiene licencia de la CNMV para operar como Plataforma de Financiación Participativa
                </strong>
              </p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <p>
                The Crowd Angel es una plataforma de financiación participativa acreditada por la Comisión Nacional del
                Mercado de Valores (CNMV) desde marzo 2017. Anteriormente, estaba operando dentro amparado por el
                proceso de tramitación de la concesión definitiva de acuerdo a la ley del 2015.
              </p>
              <div className="gap-20"/>
              <p>
                The Crowd Angel es una de las primeras plataformas de inversión participativa o crowdfunding en España,
                que trabaja continuamente para mejorar las condiciones legales que giran entorno a este modelo de
                financiación. Acercando cada vez más las oportunidades de inversión en activos alternativos a pequeños
                inversores “Business Angels” y permitiendo a los emprendedores tener más oportunidades de conseguir
                financiación para acelerar el crecimiento de sus empresas y conseguir las metas estratégicas planteadas.
              </p>
              <div className="gap-20"/>
              <p>
                Desde The Crowd Angel, queremos seguir creando modelos de financiación acordes a las necesidades del
                mercado, y esperamos poder seguir ampliando continuamente nuestra cartera de productos de acuerdo al
                marco establecido por la CNMV, para mantener así la seguridad para todos aquellos inversores que
                participen en operaciones a través de nuestra plataforma.
              </p>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 text-center">
              <img
                alt="CNMV"
                src="./img/tca_acreditacion_cnmv.png"
              />
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <p>
                <strong>
                  ¿Qué es una Plataforma de Financiación Participativa?
                </strong>
              </p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <p>
                Desde el Gobierno de España y a través de sus organismos de control, como la CNMV y el Banco de España,
                se ha creado la figura de la Plataforma de Financiación Participativa, para dar un marco legal a todas
                estas plataformas de crowdfunding que ayudan a empresas a conseguir financiación mediante la aportación
                de muchos inversores, que se ponen en contacto generalmente a través de una página web.
              </p>
              <div className="gap-20"/>
              <p>
                Como forma de regular este nuevo mercado y actores participantes, se ha decidido crear una licencia de
                obligada obtención para estas plataformas.
              </p>
              <div className="gap-20"/>
              <p>
                Este proceso obligatorio en España, surgió a raíz de la publicación en el BOE de la Ley 5/2015 de 27 de
                abril, “de fomento de la financiación empresarial”. En esta ley se establecen unos estrictos requisitos
                para la concesión de las licencias de Plataforma de Financiación Participativa bajo la supervisión de
                la CNMV y del propio Banco de España.
              </p>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 text-center">
              <img
                alt="CNMV"
                src="./img/edificio-cnmv.png"
              />
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <p>
                <strong>
                  ¿Cuales son las reglas que se imponen a las Plataformas en España?
                </strong>
              </p>
              <div className="gap-20"/>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <p>
                El marco legal de la licencia impone a las Plataformas de Financiación Participativa las reglas
                siguientes:
              </p>
              <div className="gap-20"/>
              <p>
                El importe máximo de captación de fondos por operación de financiación participativa no podrá ser
                superior a 2.000.000 de euros, si es financiada tanto por inversores acreditados y como no acreditados,
                siendo posible la realización de sucesivas rondas de financiación que no superen el referido importe en
                cómputo anual.  Ahora bien, en el caso de que las operaciones se dirijan exclusivamente a inversores no
                acreditados, el importe máximo anterior podrá alcanzar hasta los 5.000.000 de euros.
              </p>
              <div className="gap-20"/>
              <p>
                Las plataformas de crowdfunding tienen que tener un capital social mínimo de 60.000 € o tener un
                seguro de responsabilidad social. Este seguro sirve para proteger a los inversores contra cualquier
                posible negligencia de las plataformas. Si una plataforma financia inversiones en operaciones de más de
                2 millones de € el capital social tiene que ser de 120.000 €.
              </p>
              <div className="gap-20"/>
              <p>
                La plataforma tiene que dar una garantía de pagos, es decir, que aunque la plataforma desaparezca se
                continuarán pagando las cuotas de los préstamos aprobados hasta su total vencimiento.
              </p>
              <div className="gap-20"/>
              <p>
                Se tiene que depositar el dinero de los inversores en cuentas separadas de la cuenta de la empresa de
                crowdfunding.
              </p>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 text-center">
              <img
                alt="CNMV"
                src="./img/tca_acreditacion_cnmv.png"
              />
              <div className="gap-20"/>
            </div>
          </div>
        </div>
        <StartComponent/>
      </section>
    );
  }
}

export default CnmvAccreditationComponent;



// WEBPACK FOOTER //
// ./src/modules/accreditations/CnmvAccreditation.component.tsx